import React, { SyntheticEvent, useContext } from 'react';
import { Button, ChartData } from '@scholastic/volume-react';
import { useHistory } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import { transformTableData } from '../ReportChartBody/ReportTable/ReportTable.transformer';

import { ActionType, StoreContext } from '../../../state/store';
import './ReportChartHeader.scss';

interface ReportChartHeaderProps {
  reportType: string;
  productName: string;
  csvData: ChartData | undefined;
  selectedTab: string;
}

const ReportChartHeader = ({
  reportType,
  productName,
  csvData,
  selectedTab,
}: ReportChartHeaderProps) => {
  const { state, dispatch } = useContext(StoreContext);
  let history = useHistory();
  const formattedTableData = transformTableData(csvData);
  const formattedCsvData: (string | number)[][] = [
    [reportType],
    [productName],
    [selectedTab],
    ['', ...formattedTableData.columns],
  ];

  formattedTableData.rows.map((row) => {
    const rowData: (string | number)[] = [row.name, ...row.values];
    formattedCsvData.push(rowData);
    return {};
  });

  const csvReport = formattedCsvData;

  return (
    <div className="stats-charts-header">
      <div className="stats-charts-header__links-panel">
        <Button
          className="stats-charts-header__links m-1"
          color="info"
          type="button"
          href="/home"
          tag="a"
          onClick={(e: SyntheticEvent) => {
            e.preventDefault();
            dispatch({ type: ActionType.RESET, data: undefined });
            dispatch({ type: ActionType.SET_IS_AUTHENTICATED, data: state.isAuthenticated });
            dispatch({ type: ActionType.SET_CUSTOMER_INFO, data: state.customerInfo });
            history.push('/home');
          }}
          id="navigate-away"
        >
          Back to Report Selector
        </Button>
      </div>

      <div className="stats-charts-header__links-panel stats-charts-header__links-panel--export">
        <Button className="stats-charts-header__links m-1" color="info" type="button">
          <CSVLink
            className="stats-charts-header__export-btn"
            data={csvReport}
            filename={'grid_export.csv'}
          >
            Export Grid To Excel
          </CSVLink>
        </Button>

        <Button
          className="stats-charts-header__links m-1"
          onClick={() => window.print()}
          color="info"
          type="button"
          id="print"
        >
          Print
        </Button>
      </div>
    </div>
  );
};

export default ReportChartHeader;
